import React from 'react';
import ProjektanfrageButton from '../ProjectRequest/Projektanfrage';
import useReveal from '../../hooks/useReveal';
import './ProjectRequestSection.css';

const ProjectRequestSection = () => {
  const sectionRef = useReveal();

  return (
    <section className="contact-reference-section reveal" ref={sectionRef}>
      <div className="contact-reference-card">
        <div className="contact-reference-text">
          <h2>Bereit für den nächsten Schritt?</h2>
          <p>
            Erzählen Sie uns von Ihrem Projekt – wir melden uns innerhalb von
            24 Stunden mit einer kostenlosen Ersteinschätzung.
          </p>
        </div>
        <div className="contact-reference-action">
          <ProjektanfrageButton />
        </div>
      </div>
    </section>
  );
};

export default ProjectRequestSection;
